import React from "react";
import { Col, Container, Row } from "reactstrap";
import Form from "./Form";
const Card = (props) => {
  return (
    <React.Fragment>
      <Col lg={3} md={6}>
        <div className="contact-info text-center mt-5">
          <div className="icon">
            <i className={props.iconClass}></i>
          </div>
          <div className="mt-4 pt-2">
            <h6 className="fs-2">{props.title}</h6>
            {props.isChildItem.map((item, key) => (
              <p className="text-muted mb-0 fs-4" key={key}>
                {item}
              </p>
            ))}
          </div>
        </div>
      </Col>
    </React.Fragment>
  );
};

// Contact Data

const ContactData = [
  {
    title: "Negozio",
    iconClass: "mdi mdi-map-marker text-primary h4",
    isChildItem: ["Via Isonzo, 253/A 04100 Latina"],
  },
  {
    title: "Telefono/cellulare",
    iconClass: "mdi mdi-phone text-primary h4",
    isChildItem: ["Tel/Fax: +39 0773 840485", "Mobile: +39 331 1366386"],
  },
  {
    title: "Email",
    iconClass: "mdi mdi-email text-primary h4",
    isChildItem: ["tenergia2015@gmail.com"],
  },
  {
    title: "Orari lavorativi",
    iconClass: "mdi mdi-calendar-clock text-primary h4",
    isChildItem: ["Lunedì-Venerdì: 8:30-13:00 / 14:00-17:30", "Sabato-Domenica: Chiusi"],
  },
];

const Contact = () => {
  const formLayout = {
    name:'noleggio',title:"Compila il form e ti risponderemo via mail",layout:[
        {fieldName:'nome',fieldDimensions:12,fieldLabel:'Nome e Cognome',fieldValidation:{required:true},fieldType:'text'},
        {fieldName:'email',fieldDimensions:6,fieldLabel:'Indirizzo email',fieldValidation:{required:true},fieldType:'email'},
        {fieldName:'telefono',fieldDimensions:6,fieldLabel:'Numero di telefono',fieldValidation:{required:true},fieldType:'number'},
        {fieldName:'messaggio',fieldDimensions:12,fieldLabel:'Messaggio',fieldValidation:{},fieldType:'textarea'},
    ]
}    
  return (
    <React.Fragment>
      <section className="section" id="contact">
        <Container>
          <Row className="justify-content-center">
            <Col lg={7}>
              <div className="text-center mb-4">
                <h3 className="fs-1">Contattaci</h3>
                <div className="title-border mt-3"></div>
              </div>
            </Col>
          </Row>

          {/*  */}

          <Row className="justify-content-center">
            {/* Contact Component Start */}

            {ContactData.map((value, idx) => (
              <Card
                key={idx}
                title={value.title}
                iconClass={value.iconClass}
                isChildItem={value.isChildItem}
              />
            ))}
            {/* Contact Component End */}
          </Row>
          <Row className="align-items-center">
          <Form name={formLayout.name} title="" layout={formLayout.layout}></Form>
          </Row>
          </Container>
      </section>
    </React.Fragment>
  );
};

export default Contact;
